<template>
    <v-card tile flat class="result-text theme-title transparent" :class="team.component.position ==='appBar' ? 'appbar-result-action': 'main-result'">
        {{ score ? score : 0 }}
    </v-card>
</template>

<script>
    import eventBus from '@/eventBus';
    import CONSTANTS from '../constants';

    export default {
        name: "TeamScore",
        props: {
            team: Object,
            score: Number,
            teamId: String,
            gamedata: Object
        },
        methods: {
            increase: function(teamId) {
                /*let localGameData = Object.assign({}, this.gamedata);
                teamId = teamId !== null ? teamId : this.teamId;
                if(teamId === 'teamA') {
                    localGameData.team_a_score = localGameData.team_a_score + 1;
                }
                else if(teamId === 'teamB'){
                    localGameData.team_b_score = localGameData.team_b_score + 1;
                }
                eventBus.$emit(CONSTANTS.EVENTS.SET.GAMEDATA, localGameData);*/
            },
            decrease: function(teamId) {
                /*let localGameData = Object.assign({}, this.gamedata);
                teamId = teamId !== null ? teamId : this.teamId;
                if(teamId === 'teamA') {
                    localGameData.team_a_score = localGameData.team_a_score > 0 ? localGameData.team_a_score + 1 : 0;
                }
                else if(teamId === 'teamB'){
                    localGameData.team_b_score = localGameData.team_b_score > 0 ? localGameData.team_b_score - 1 : 0;
                }
                eventBus.$emit(CONSTANTS.EVENTS.SET.GAMEDATA, localGameData);
                 */
            }
        }
    }
</script>

<style scoped>
    @font-face {
        font-family: TickingTimebombBB;
        src: url('~@/assets/TickingTimebombBB.otf') format("opentype");
    }

    .main-result.result-text {
        min-width: 34px;
    }

    .appbar-result-action.result-text {
        font-family: TickingTimebombBB;
        font-size: 33px;
        font-style: normal;
        background: transparent;
    }
</style>
